import React from 'react';
import './ShowcaseImage.css'; // Make sure the path to the CSS file is correct

const ShowcaseImage = () => {
  return (
    <div className="showcase-image-container">
      <img src="/assets/images/weddingvideographer-near-me.webp" alt="Wedding Videography" />
    </div>
  );
};

export default ShowcaseImage;
